import fetcher from '../lib/fetcher'
import {TNetworkDashboard, TDashboardFilters} from '../types/dashboard.type'
import {NetworkDashboardSchema} from '../schemas/dashboard.schemas'

const getNetworkDashboard = async (
  networkId: string,
  from: string,
  to: string,
  filters: TDashboardFilters,
): Promise<TNetworkDashboard> => {
  const params = new URLSearchParams()
  params.set('from', from)
  params.set('to', to)
  // activityList convention: comma-joined, omitted entirely when empty.
  if (filters.teamIds.length > 0) {
    params.append('teamIds', filters.teamIds.join(','))
  }
  if (filters.activityTypes.length > 0) {
    params.append('activityTypes', filters.activityTypes.join(','))
  }
  if (filters.statuses.length > 0) {
    params.append('statuses', filters.statuses.join(','))
  }
  if (filters.shift !== 'both') {
    params.set('shift', filters.shift)
  }
  const response = await fetcher.get<TNetworkDashboard>(
    `/api/network/${networkId}/dashboard?${params.toString()}`,
  )
  return NetworkDashboardSchema.parse(response.data)
}

const DashboardService = {
  getNetworkDashboard,
}

export default DashboardService
